import { render, staticRenderFns } from "./SwingList.vue?vue&type=template&id=4a495f88&"
import script from "./SwingList.vue?vue&type=script&lang=js&"
export * from "./SwingList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports